<template>
    <div
        class="a-control a-control--hasButton a-control--search m-search"
        :class="{'a-control--error':error}"
    >
        <a-select
            class="m-search__control"
            placeholder="Znajdź środek..."
            @input="searchQuery = $event"
            @quick-search-click="handleClick($event)"
            @enter="search"
            :value="searchQuery"
            name="search"
            model-name="protectors"
            id="mControl-search"
            :object="false"
            vuex-fetch-quick-search="fetchFullQuickSearch"
            :disable-on-click="true"
        ></a-select>
        <button
            class="a-control__button"
            @click="search"
            ref="button"
        >
            <a-icon icon="Filter" />
        </button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchQuery: '',
            error: false
        }
    },
    computed: {
        query() {
            return this.$store.getters.protectorsQuery
        }
    },
    watch: {
        searchQuery() {
            if(this.searchQuery.length >= 3) {
                this.error = false
            }
        }
    },
    methods: {
        search() {
            window.scrollTo(0, 0)
            if(this.searchQuery.length >= 3) {
                this.error = false
                this.$store.dispatch('resetProtectorsQuery').then(() => {
                    this.$store.dispatch('setProtectorsSearchQuery', {
                        name: 'search',
                        value: this.searchQuery
                    }).then(() => {
                        if(this.$route.name !== 'protectors') {
                            this.$router.push({ name: 'protectors' })
                        } else {
                            this.$store.dispatch('fetchProtectors')
                        }
                        this.$refs.button.focus()
                        this.searchQuery = ''
                    })
                })
            } else {
                this.error = true
            }
        },
        handleClick($event) {
            this.error = false
            this.$store.dispatch('resetProtectorsQuery').then(() => {
                if($event.name && $event.link) {
                    this.$store.dispatch('setProtectorsSearchBy', {
                        name: $event.name,
                        link: $event.link
                    }).then(() => {
                        if(this.$route.name !== 'protectors') {
                            this.$router.push({ name: 'protectors' })
                        } else {
                            this.$store.dispatch('fetchProtectors')
                        }
                        this.$refs.button.focus()
                        this.searchQuery = ''
                    })
                } else if($event.name && $event.id) {
                    this.$router.push({
                        name: 'protector',
                        params: {
                            id: $event.id
                        }
                    }).catch(() => {})
                    this.searchQuery = ''
                }
            })
        }
    }
}
</script>
